import React from "react";


const Display =({displayContent})=>{
    return (
        <div>
            {displayContent}
        </div>
    )
}


export default Display;